<template>
  <div class="works-component modernLuxurious1">
    <div class="banner"> 
      <img src="../../../assets/img/works/design concept-1500x1500/18-3D-THE FIVE OLD KLANG ROAD (TERRENCE HOUSE) - MODERN MINIMALIST 现代极简风/2.jpg" alt="">
    </div>
    <div class="border-bottom-1px">
      <div class="container ">
        <p class="playfair playfair-display-sm-400 black text-left m-0">
          Modern Minimalist | 现代极简风
        </p>
      </div>
    </div>
    <div class="container p-112 works-img border-bottom-1px"> 
      <b-row sm>
        <b-col v-for="(img, index) in resolvedImages" :key="index" md="6">
          <img class="image-fixed-height cursor-pointer" :src="img" :alt="'Image ' + (index + 1)"
            @click="showLightbox(index)">
        </b-col>
        <!-- <b-col v-for="(img, index) in images" :key="index" md="6" sm>
          <img  class="image-fixed-height" :src="require(`@/assets/img/works/design concept-1500x1500/18-3D-THE FIVE OLD KLANG ROAD (TERRENCE HOUSE) - MODERN MINIMALIST 现代极简风/${img}`)" :alt="'Image ' + (index + 1)">
        </b-col>  -->
      </b-row>
       
    </div>
    <div class="container p-112 works-img">
      <b-row >
        <b-col md="4" class="pb-24"> 
          <b-row class="flex-center">
            <b-col cols="3" to="modern-contemporary-5"  tag="router-link"><img class="icon-expand cursor-pointer" src="../../../assets/img/icon/expand_circle_left.svg"></b-col>
            <b-col cols="9" class="text-right">
              <p class="inter inter-body-md-600 black  p-0">PREVIOUS PROJECT</p>
              <p class="playfair playfair-title-lg-400 black p-0">现代简约风 | Modern Contemporary</p>
              <p class="inter inter-body-md-400 black p-0">Skyz Residence | Puchong</p>
            </b-col> 
          </b-row>
        </b-col>
        <b-col md="4" sm> 
        </b-col>
        <b-col md="4" sm> 
          <b-row class="flex-center">
            <b-col cols="9" class="text-left">
              <p class="inter inter-body-md-600 black  p-0">NEXT PROJECT</p>
              <p class="playfair playfair-title-lg-400 black p-0">现代温润极简风 | Modern Warm Minimalism</p>
              <p class="inter inter-body-md-400 black p-0">D'Erica Residences | Damansara Perdana</p>
            </b-col>
            <b-col cols="3"  to="modern-warm-minimalism"  tag="router-link"><img class="icon-expand cursor-pointer" src="../../../assets/img/icon/expand_circle_right.svg" alt=""></b-col>
          </b-row>
          
        </b-col>
      </b-row>
    </div>
    <!-- Lightbox -->
    <GlobalLightbox :visible.sync="lightboxVisible" :images="resolvedImages" :index="currentIndex" />
  </div>

</template>

<script>
import GlobalLightbox from '@/components/GlobalLightbox.vue'

export default {
  name: 'RetroContactComponent',
  components: {
    GlobalLightbox
  },
  data() {
    return { 
      images: [ 
        "1.jpg", 
        "3.jpg", 
        "4.jpg",
        "5.jpg",  
        "6.jpg", 
        "7.jpg", 
        "8.jpg", 
        "9.jpg", 
        "10.jpg",  
        "11.jpg",
        "12.jpg",
        "13.jpg",
        "14.jpg",
        "15.jpg",
        "16.jpg",
      ],

      lightboxVisible: false,
      currentIndex: 0
    }
  },
  methods: { 
    showLightbox(index) {
      this.currentIndex = index;
      this.lightboxVisible = true;
    },
  }, 
computed: {
    resolvedImages() {
      return this.images.map(img =>
        require(`@/assets/img/works/design concept-1500x1500/18-3D-THE FIVE OLD KLANG ROAD (TERRENCE HOUSE) - MODERN MINIMALIST 现代极简风/${img}`)
      );
    }
  }
}
</script>

<style>
 
.modernLuxurious1{
  background-color: #FFF ;
}
.banner img, .works-img img{
  width: 100%;
}
.works-img img{
  padding-bottom: 24px;
}
.modernLuxurious1 p {
  padding: 24px 0;  
}
.p-112{
  padding: 112px 0 88px;
}
.works-component .amalfi-coast-title {
  padding-bottom: 4rem;
}

.letter-spacing {
  letter-spacing: 0.5em;
  padding-bottom: 56px
}
img.icon-expand{
  width: auto;
}
.image-fixed-height {
  width: 100%;  /* Ensures image takes full width of the column */
  height: 377px; /* Set a fixed height (adjust as needed) */
  object-fit: cover; /* Ensures images fill the space without distortion */
  display: block; /* Removes extra spacing below inline images */
}
@media (max-width: 576px) { 
  .image-fixed-height {
    height: auto;
  }
}
</style>